import { useAppDispatch, useAppSelector } from '../store/hooks';
import { useCallback, useEffect } from 'react';
import { ServerModel } from '../models/serverModel';
import { selectAllServers, selectErrorsForServers, selectIsLoadingServers } from '../store/servers/serversSelector';
import { fetchAllServers } from '../store/servers/serversActions';
import { AppError } from '../types/appError';

export const useServerList = (): [
  { servers: ServerModel[], isLoading: boolean, errors: AppError[] },
  { refreshAll: () => void },
] => {
  const dispatch = useAppDispatch();
  const servers = useAppSelector(selectAllServers);
  const isLoading = useAppSelector(selectIsLoadingServers);
  const errors = useAppSelector(selectErrorsForServers);

  const fetchServers = useCallback(() => {
    dispatch(fetchAllServers());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllServers());
  }, [dispatch]);

  return [
    { servers, isLoading, errors },
    { refreshAll: fetchServers },
  ];
};
